import React from "react";
import { Button } from "@material-ui/core";
import { Tooltip } from "react-tooltip";
import { commonStyles } from "./types";

interface AccountStatusSectionProps {
  values: {
    manuallyActive: boolean;
  };
  setFieldValue: (field: string, value: any) => void;
  isTrial: boolean;
}

export const AccountStatusSection: React.FC<AccountStatusSectionProps> = ({
  values,
  setFieldValue,
  isTrial,
}) => {
  const { labelClassName } = commonStyles;

  return (
    <div className="field flex flex-col">
      <label
        htmlFor="manuallyActive"
        className={labelClassName + " whitespace-nowrap"}
      >
        Statut du compte
      </label>
      <Tooltip
        id="manuallyActive"
        delayHide={33000}
        className="max-w-[300px] text-center rounded-xl pointer-events-auto"
        noArrow
      ></Tooltip>
      <Button
        data-tooltip-id="manuallyActive"
        data-tooltip-html={
          isTrial
            ? "<p>Mettre à niveau votre abonnement pour pouvoir changer le statut du chauffeur. \n </p><a style='cursor:pointer; text-decoration:underline' href='/subscription'>Cliquez ici pour en savoir plus </a>"
            : ""
        }
        startIcon={
          values.manuallyActive ? (
            <i className="pi pi-check-circle text-md"></i>
          ) : (
            <i className="pi pi-times-circle text-md"></i>
          )
        }
        className={`p-button-md text-white rounded-lg py-3 !m-0 border-none focus:outline-none font-sans capitalize text-lg ${
          values.manuallyActive
            ? "p-button-primary bg-primary"
            : "p-button-secondary bg-red-400"
        } ${isTrial ? "cursor-not-allowed" : ""}`}
        onClick={() =>
          !isTrial && setFieldValue("manuallyActive", !values.manuallyActive)
        }
      >
        {values.manuallyActive ? "Actif" : "Inactif"}
      </Button>
    </div>
  );
};
